module.exports = __webpack_public_path__ + "img/album.05fbd159.png";